import React, {useEffect, useRef, useState} from 'react';
import { Button, Popconfirm, Row, Space, Table, Typography } from 'antd'
import { ExcelSVG } from 'assets'
import Icons from 'assets/icons'
import { bedColumns, roomColumns } from './config';
import Tooltip from 'antd/lib/tooltip';
import {inpatientService} from 'api';
import './SickBedCatalog.scss';
import { ColumnsType } from 'antd/es/table';
import NewBedCatalog from './NewBedCatalog/NewBedCatalog';
import Notification from 'components/common/notification/notification';
import NewRoomCatalog from './NewRoomCatalog/NewRoomCatalog';

const SickBedCatalog = () => {
  
  const [loading, setLoading] = useState<boolean>(false);
  const [bedData, setBedData] = useState<any>(null);
  const [bpage, setBpage] = useState<number>(1);
  const [blimit, setBlimit] = useState<number>(10);
  const [roomData, setRoomData] = useState<any>(null);
  const [rpage, setRpage] = useState<number>(1);
  const [rlimit, setRlimit] = useState<number>(10);

  const newBRef = useRef<any>(null);
  const newRRef = useRef<any>(null);
  const onRemoveBedCatalog = async (record) => {
    try {
      let response = await inpatientService.delBedCatalog({id: record.id})
      Notification("success", "Thanh công!")
      fetchDanhMucGiuongBenh({page: bpage, limit: blimit})
    } catch (err) {
      
    }
  }
  const onUpdateBedCatalog = async (record) => {
    newBRef.current?.setData(record);
    newBRef.current?.openModal();
  }
  bedColumns.map(it => {
    if(it.dataIndex === 'stt') {
      it.render = (v, r, i) => (i + 1 + (bpage-1) * blimit)
    }
    if(it.dataIndex === 'action') {
      
      it.render = (v, r, i) => {
          return (
            <Row justify={'center'}>
              <Space>
                <Tooltip title="Xóa">
                  <Popconfirm title={"Đồng ý xoá?"} onConfirm={() => onRemoveBedCatalog(r)}>
                    <Button icon={<Icons.remove />} danger></Button>
                  </Popconfirm>
                </Tooltip>
                <Tooltip title="Sửa">
                  <Button icon={<Icons.edit />} onClick={() => onUpdateBedCatalog(r)}></Button>
                </Tooltip>
              </Space>
            </Row>
          )
        }
      }
    }
  )
  const onRemoveRoomCatalog = async (record) => {
    try {
      let response = await inpatientService.delRoomCatalog({id: record.id})
      Notification("success", "Thanh công!")
      fetchDanhMucPhongBenh({page: rpage, limit: rlimit})
    } catch (err) {
      
    }
  }
  const onUpdateRoomCatalog = async (record) => {
    newRRef.current?.setData(record);
    newRRef.current?.openModal();
  }
  roomColumns.map(it => {
    if(it.dataIndex === 'stt') {
      it.render = (v, r, i) => (i + 1 + (rpage-1) * rlimit)
    }
    if(it.dataIndex === 'action') {
      
      it.render = (v, r, i) => {
        return (
          <Row justify={'center'}>
            <Space>
              <Tooltip title="Xóa">
                <Popconfirm title={"Đồng ý xoá?"} onConfirm={() => onRemoveRoomCatalog(r)}>
                  <Button icon={<Icons.remove />} danger></Button>
                </Popconfirm>
              </Tooltip>
              <Tooltip title="Sửa">
                <Button icon={<Icons.edit />} onClick={() => onUpdateRoomCatalog(r)}></Button>
              </Tooltip>
            </Space>
          </Row>
        )}
    }
  })
  const onAddBedCatalog = () => {
    newBRef.current?.openModal()
  }
  const onAddRoomCatalog = () => {
    newRRef.current?.openModal()
  }
  // fetch 

  const fetchDanhMucGiuongBenh = async (params) => {
    try {
      setLoading(true)
      let response = await inpatientService.getListDanhMucGiuongBenh(params)
      setBpage(response.page)
      setBlimit(response.limit)
      setBedData(response)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  const fetchDanhMucPhongBenh = async (params) => {
    try {
      setLoading(true)
      let response = await inpatientService.getListDanhMucPhongBenh(params)
      setRpage(response.page)
      setRlimit(response.limit)
      setRoomData(response)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }

  //
  const onRowSelectChange = (selectedRowKeys, selectedRows, info) => {

  }
  const onPageChange = (pg, lm) => {
    setBpage(pg)
    setBlimit(lm)
    fetchDanhMucGiuongBenh({
      page: pg,
      limit: lm
    })
  }
  const onRPageChange = (pg, lm) => {
    setRpage(pg)
    setRlimit(lm)
    fetchDanhMucPhongBenh({
      page: pg,
      limit: lm
    })
  }
  const addNewBedCatalog = async (data, type) => {
    try {
      let response;
      if(type ===0)
        response = await inpatientService.postAddBedCatalog(data);
      else if(type === 1)
        response = await inpatientService.putBedCatalog(data);
      Notification("success","Thành công!")
      fetchDanhMucGiuongBenh({page: bpage, limit: blimit})
    } catch (err) {
      
    }
  }
  const addNewRoomCatalog = async (data, type) => {
    try {
      let response;
      if(type ===0)
        response = await inpatientService.postAddRoomCatalog(data);
      else if(type === 1)
        response = await inpatientService.putRoomCatalog(data);
      Notification("success","Thêm thành công!")
      fetchDanhMucPhongBenh({page: rpage, limit: rlimit})
    } catch (err) {
      
    }
  }
  useEffect(() => {
    fetchDanhMucGiuongBenh({page: bpage, limit: blimit})
    fetchDanhMucPhongBenh({page: rpage, limit: rlimit})
  },[])
  useEffect(() => {

  }, [bedData, roomData, bpage, blimit])
  return (
  <div className='sick-bed-catalog'>
    <div className="container">
      <Typography.Text style={{fontWeight: 'bold'}}></Typography.Text>
      <Row gutter={[16, 8]}>
        <Row justify={'end'}>
          <Space>
            <Button icon={<ExcelSVG />} className="custom-btn">
              Xuất báo cáo
            </Button>
            <Button type='primary' className='btn-sub' icon={<Icons.add />} onClick={onAddBedCatalog}>Thêm</Button>
            <NewBedCatalog ref={newBRef} danhMucPhong={roomData} onSave={addNewBedCatalog}/>
          </Space>
        </Row>
        <Row>
          <Table
            rowKey={record => record.id}
            columns={bedColumns as ColumnsType}
            dataSource={bedData ? bedData.data: []}
            bordered
            loading={loading}
            pagination={{
              showSizeChanger: true,
              total: bedData?.total,
              pageSize: bedData?.limit,
              current: bedData?.page,
              onChange: onPageChange
            }}
            // rowSelection={{
            //   type: 'checkbox',
            //   onChange: onRowSelectChange
            // }}
          />
        </Row>
      </Row>
    </div>
    <div className="container">
      <Typography.Text style={{fontWeight: 'bold'}}></Typography.Text>
      <Row gutter={[16, 8]}>
        <Row justify={'end'}>
          <Space>
            <Button icon={<ExcelSVG />} className="custom-btn">
              Xuất báo cáo
            </Button>
            <Button type='primary' className='btn-sub' icon={<Icons.add />} onClick={onAddRoomCatalog}>Thêm</Button>
            <NewRoomCatalog ref={newRRef} onSave={addNewRoomCatalog}/>
          </Space>
        </Row>
        <Row>
          <Table
            rowKey={record => record.id}
            columns={roomColumns as ColumnsType}
            dataSource={roomData ? roomData.data: []}
            bordered
            loading={loading}
            pagination={{
              showSizeChanger: true,
              total: roomData?.total,
              current: roomData?.page,
              pageSize: roomData?.limit,
              onChange: onRPageChange
            }}
            // rowSelection={{
            //   type: 'checkbox',
            //   onChange: onRowSelectChange
            // }}
          />
        </Row>
      </Row>
    </div>
  </div> 
)
}

export default SickBedCatalog